/*
PW Confirm Menu Item
Extension of Menu Item that requires User Confirmation Prior to allowing the click action
*/
import React from 'react'
import T from 'prop-types'
import _ from 'lodash'
import MenuItem from './MenuItem'
import ConfirmAction from './ConfirmAction'
import MenuOwner from './MenuOwner'

export default class ConfirmMenuItem extends React.Component {
  static displayName = 'ConfirmMenuItem'

  static propTypes = {
    args: T.any, // Accepts either single string value or an array of args
    children: T.node,
    confirmMessage: T.string,
    confirmText: T.string,
    disabled: T.bool,
    onClick: T.func.isRequired,
    confirmBtnTestId: T.string
  }

  static defaultProps = {
    confirmMessage: 'Please confirm the requested action.',
    disabled: false
  }

  constructor(props) {
    super(props)
    this.state = {
      isMenuOpen: false
    }
  }

  _handleConfirmed = () => {
    this.closeMenu() // Close menu first in case this is nested in a DropdownMenu
    if (_.isArray(this.props.args)) {
      const args = _.flatten(this.props.args)
      this.props.onClick.apply(this, args)
    } else {
      this.props.onClick(this.props.args)
    }
  }

  openMenu = () => {
    this.setState({ isMenuOpen: true })
  }

  closeMenu = () => {
    this.setState({ isMenuOpen: false })
  }

  _renderMenu = () => {
    const { confirmBtnTestId, confirmText, confirmMessage } = this.props
    return (
      <ConfirmAction
        className="sensor_mode_confirm"
        confirmText={confirmText}
        confirmBtnTestId={confirmBtnTestId}
        message={confirmMessage}
        onCanceled={this.closeMenu}
        onConfirmed={this._handleConfirmed}
      />
    )
  }

  render() {
    const { disabled, children } = this.props
    const { isMenuOpen } = this.state
    return (
      <MenuItem
        {..._.omit(
          this.props,
          'confirmMessage',
          'confirmText',
          'confirmBtnTestId'
        )}
        onClick={!disabled ? this.openMenu : _.noop}
      >
        <MenuOwner
          onClose={this.closeMenu}
          renderMenu={this._renderMenu}
          isMenuOpen={isMenuOpen}
        >
          {children}
        </MenuOwner>
      </MenuItem>
    )
  }
}
